<template>
<content-div v-if="onload">
  <!-- 차량등록(구독데이터 有)회원 -->
  <template v-if="$store.state.user.vtg_id && vehicles.length!=0">

    <!-- <vehicle-carousel v-if="vehicles" :items="vehicles" :selected.sync="selected"/> -->

    <div class="vehicleList" v-if="vehicles" style="padding: 20px 15px;">
      <div class="sCon" :class="vToggle ? 'on' : ''" @click="vehiclesDrop" style="display: flex; ">
        <span class="cat-detail-title">
          {{ vehicles[selected].vehicle_cat_detail }}
        </span>
        <div class="arrow-half" :class="vToggle ? '' : 'rotated-text-half'">▴</div>
      </div>
      
      <ul class="float-ul" :class="vToggle ? 'on' : ''" style="width: calc(100% - 20px);">
          <li v-for="(item, idx) in vehicles" :key="`vehicle_${idx}`" 
            :class="{'vline' : idx+1 < vehicles.length, 'on' : item.num_id === vehicles[selected].num_id}"
            @click="selected=idx; vToggle=false;">
            <span>{{ item.vehicle_cat_detail }}</span>
            <div :class="(item.num_id === vehicles[selected].num_id ? 'check-icon check-icon--apply-origin' : '')"></div>
          </li>
      </ul>
    </div>


    <div class="contArea coupon">

      <div class="titWrap">
        <h3 class="conTit1">가입 멤버십 정보</h3>
      </div>

      <subsc-list :items="subscs[selected]" :vehicle="vehicles[selected]"
       @popupOpen="popupOpen"
       @takePicture="takePicture"
      />

      <div class="titWrap">
        <h3 class="conTit1">멤버십 제공 서비스</h3>
      </div>

    </div>
    
    <subsc-prod-list :subsc-id="subscProds[selected]"/>

  </template>
  
  <!-- 구독정보 없거나 비회원 -->
  <subsc-list-none v-else/>

  <!-- 해지신청 취소 / 연장신청 관련 팝업 :btn_submit="false" :btn_cancel="true" -->
  <popup-alert v-if="activate" title="알림" @close="activate=false" :btn_submit="true">
    <popup-msg :type="popupMsg" @close="activate=false" @action="popupAction"></popup-msg>
  </popup-alert>

  <popup-alert v-if="activateUpload" title="알림" @close="activateUpload=false" >
    반려서류 업로드 완료되었습니다.
  </popup-alert>

  <!--차량 정보 수정-->
  <VehicleModifyDialog v-if="subscs"
      v-bind:subsc="subscs[this.selected][0]"
      v-bind:user="user"
      ref="vehicleModifyDialog"
      @closed="getSubscs()"
  />

  <!--계기판 정보 수정-->
  <PanelModifyDialog v-if="subscs"
      ref="panelModifyDialog"
      v-bind:subsc="subscs[this.selected][0]"
      @closed="getSubscs()"
  />


</content-div>
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";
  import Const from "../../../helpers/Const.js";

  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import PopupMsg from "@/components/Popup/PopupMsgTemplate";
  import VehicleCarousel from "@/components/VehicleCarousel.vue";

  import SubscList from "./SubscListView.vue";
  import SubscProdList from "./SubscProdListView.vue";
  import SubscListNone from "./SubscListNoneView.vue";
  import VehicleModifyDialog from "./components/VehicleModifyDialog";
  import PanelModifyDialog from "./components/PanelModifyDialog";

  export default {
    name:'SubscVtg',
    components: {
      PopupAlert,
      PopupMsg,
      SubscList,
      SubscListNone,
      SubscProdList,
      VehicleCarousel,

      VehicleModifyDialog,
      PanelModifyDialog,
    },

    created() {
      //app or dev check  false -> route notApp
      this.CheckAppDev();
      this.getSubscs();
    },

    data() {
      return {
        vToggle: false,
        activateUpload: false,
        activate: false,
        emitParam: {},
        onload: false,
        popupMsg: '',
        selected: 0,
        subscProds: [],
        user: null,
        subscs: [],
        vehicles: [],
      };
    },
    methods: {
      vehiclesDrop() {
        this.vToggle = !this.vToggle;
      },

      getSubscs() {
        // 구독해지취소신청 등 redirect 기능구현을 위해 data reset    20.03.23    sang
        this.onload = false;
        this.vehicles = [];
        this.subscs = [];

        //vtg_id 가 없을경우
        if(!this.$store.state.user.vtg_id) {
          this.$store.commit('setPopup401', true);
          return;
        }

        //vtg_id가 있지만 token이 존재하지 않을경우 (prime 내 미가입상태)
        if(this.$store.state.user.id == 0){
          this.onload = true;
          return;
        }

        this.$store.commit('setBtnLoading', true);
        // 2022-05-04 jeon
        // vtg_id 암호화 데이터 전체데이터를 가져와 filter한다 오래걸린다... id변경
        // axios.get(`${api.users}/showByPlusId/${this.$store.state.user.vtg_id}`)
        axios.get(`${api.users}/${this.$store.state.user.id}`)
          .then(({data}) => {
            const vehicle = data.data.vehicles;
            const subscs = data.data.subscs;
            this.user = data.data;

            for (let i in vehicle) {
              // id가 key 가 아닌 이유는 carousel 사용시 sync return값을 index 로만 반환하기 때문에(event.currentSlide)
              this.vehicles[i] = {
                'id': vehicle[i].id,
                'num_id': vehicle[i].num_id,
                'num_reg': vehicle[i].num_reg,
                'date_reg': vehicle[i].date_registered,
                'model': vehicle[i].vehicle_cat.title,
                'model_year': vehicle[i].model_year,
                'vehicle_cat_id': vehicle[i].vehicle_cat_id,
                'vehicle_cat_detail': vehicle[i].vehicle_cat_detail
              }

              // 2021-04-05 jeon
              // 이관신청 표기를 위해 사용->차량->구독이 아닌 사용자->구독으로 list를 setting 한다.
              this.subscs[i] = subscs.filter((e)=>{ return e.vehicle_num_id == vehicle[i].num_id });

              // prime 에 vehicle(차량)이 등록된 경우 = 구독데이터 최소 1개 보유/ 혹시 모를 error발생 예방을 위해 배열선언
              // this.subscs[i] = [];
              // if (vehicle[i].subscs.length != 0) this.subscs[i] = vehicle[i].subscs;

              // index를 key로 차량별로 구독중인 데이터 id 저장
              // -> select가 바뀔때마다 server에서 subsc_id로 쿠폰정보 표시하기 위해
              this.subscs[i].forEach((subsc) => {
                //차량 구독중 가입중인 데이터의 상품만 가져온다.
                if(subsc.state == Const.SUBSC_STATE.ENABLE)
                  this.subscProds[i] = subsc.id;
              });

            }
            
            const num_id = this.$route.query.vehicle_id;
            if(num_id) {
              this.selected = this.vehicles.findIndex(e=>e.num_id === num_id);
            }

            this.onload = true;
          })
          .catch((error) => {
            const errCode = error.response.status;
            //401 = token X  &&  409 = 유저 X
            if(errCode == 401){
              this.$store.commit('setPopup401', true);
              return;
            } else if (errCode != 409) {
              this.popupMsg = this.errorMsg(error);
              this.activate = true;
            }
            this.onload = true;
          })
      },

      popupAction() {
        if (this.popupMsg == 'SUBSC_REVOKE_CANCEL') {
          this.setSubscRevokeCancel();
        } else if (this.popupMsg == 'SUBSC_EXTEND_WARNING') {
          this.setSubscExt(true);
        }
      },

      popupOpen(type, param) {
        this.emitParam = param;
        if (type == 'extends') {
          this.setSubscExt();
        } else if (type == 'revoke') {
          this.popupMsg = 'SUBSC_REVOKE_CANCEL';
          this.activate = true;
        } else if (type == 'revoke_apply') {
          const vtgId = this.$store.state.user.vtg_id.toString();
          this.$router.push(`/subscRevoke?vtg_id=${vtgId}&subsc_id=${param.subsc_id}`);
        }
      },

      // 구독 연장신청
      setSubscExt(dev) {

        const vehicle = this.vehicles[this.selected];
        if (!this.$store.state.isApp && !dev) {
          this.popupMsg = 'SUBSC_EXTEND_WARNING';
          this.activate = true;
          return;
        }

        const vehicleData = {
          user_name: this.$store.state.user.name,
          date_reg: vehicle.date_reg,
          num_reg: vehicle.num_reg,
          num_id: vehicle.num_id,
          model_type: vehicle.model,
          model_year: vehicle.model_year,
          month_diff_index: this.getVehicleNumRegMonthDiff(vehicle.date_reg) // 차량등록일로부터 개월수 계산
        }

        this.$store.commit('setVehicle', vehicleData);
        // this.$store.state.pkg.id = this.emitParam.pkg.id;    // 기존 패키지 자동선택
        // this.$store.state.pkg.title = this.emitParam.pkg.title;    // 기존 패키지 자동선택
        this.$store.state.subsc.state_req = Const.SUBSC_STATE_REQ.ENABLE_EXT;    // subsc 에 연장신청 flag
        // 연장신청의 경우 화면에 출력되는 구독일자가 만료일자 다음일을 기준으로 표시되어야 함
        this.$store.state.subsc.date_start = this.$moment(this.emitParam.date_stop).add(1, 'days').format('YYYY-MM-DD');
        this.$store.state.subsc.parent_subsc_id = this.emitParam.subsc_id;   // 연장신청 대상 구독 id
        this.$router.push('/subscApply/pkg');
      },

      // 해지신청 취소
      setSubscRevokeCancel() {
        this.activate = false;

        if(this.$store.state.btnLoading) return;
        this.$store.commit('setBtnLoading', true);

        const axiosParam = {'state_req': Const.SUBSC_STATE_REQ.DISABLE_REVOKE_CANCEL};
        axios.put(`${api.subscs}/${this.emitParam.subsc_id}`, axiosParam)
          .then(() => {
            this.popupMsg = 'SUBSC_REVOKE_CANCEL_COMPLETE';
            this.activate = true;
            this.getSubscs();
          })
          .catch((error) => {
            if(error.response.status == 401)
              this.$store.commit('setPopup401', true);
            else {
              this.popupMsg = this.errorMsg(error);
              this.activate = true;
            }
              // throw error;
          })
      },

      takePicture(type, subsc) {
        const vtgId = this.$store.state.user.vtg_id.toString();
        const url = `${this.S3UploadURL}/subsc/${subsc.id}`;
        if (this.$store.state.isApp) {
          //차량등록증
          if(type == Const.SUBSC_ATT.REG) {
            /*global runOCRCarReg*/
            runOCRCarReg(vtgId, 'handleKey', url);
          }
          // 차동차정기검사 결과표 , 계기판
          else if(
            type == Const.SUBSC_ATT.INSP ||
            type == Const.SUBSC_ATT.PANEL
          ) {
            /*global runTakePictureAndUpload*/
            runTakePictureAndUpload(vtgId, Const.getTakePictureType()[type], url);
          }
        } else if(this.$store.state.isDev) {
          this.callbackOCRCarReg(type);
        }
      },

      //app OCR 콜백 위치 (저장성공)
      callbackOCRCarReg(type) {
        this.activateUpload = true;

        switch (type){
          case Const.SUBSC_ATT.REG:   // 차량 등록증
            this.$refs.vehicleModifyDialog.open();
            break;
          case Const.SUBSC_ATT.PANEL: // 계기판
            this.$refs.panelModifyDialog.open();
            break;
          case Const.SUBSC_ATT.INSP:  // 검사표
            this.getSubscs()
            break;
        }
        this.getSubscs();
      },

      // app 사진촬영 콜백 위치 (저장성공)
      callbackRunTakePicture() {
        this.activateUpload = true;
        this.getSubscs();
      },
    }
  };
</script>

<style>
  .float-ul {
    display: none;
    border: 1px solid #BBBBBB;
    z-index: 2;
  }
  .float-ul.on {
    display: block;
    position: absolute;
  }
  .float-ul li {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .float-ul li.vline {
    border-bottom: 1px solid #ccc;
  }
  .float-ul li.on {
    background-color: #F4F4F4;
  }
  .float-ul li:hover{
    color: #0068dc;
    background-color: #F4F4F4;
  }
  .check-icon {
    width: 13.23px;
    height: 10px;
    border: 2px solid #0068dc;
    margin-bottom: 4px;
  }
  .check-icon--apply-origin {
    border: 2px solid #0068dc;
    border-top: 0;
    border-right: 0;
    transform: rotate(-45deg);
    transform-origin: 25% 25%;
  }

  .vehicleList .cat-detail-title {
    font-size: 22px;
    font-weight: 700;
  }
  .vehicleList .arrow-half {
    line-height: 27px;
    padding: 0 5px;
  }
  .vehicleList ul {
    max-height: 30%;
    overflow-y: auto;
  }
  .rotated-text-half {
    transform: rotate(180deg);
  }
  
</style>